﻿import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Http } from '@angular/http';

import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import 'rxjs/add/operator/toPromise';

import { User } from './user';
import { Config } from '../config/config';


declare var config: Config;
export const USER_SESSION = 'userInfo';

@Injectable()
export class AuthService {

    //#region  Properties
    private authenticationInProgress: boolean = false;
    private _loginPromise: Promise<void> = null;

    private get _user(): User { return this.getUserFromSession(); }
    private set _user(value) { this.setUSerToSession(value); }


    public get user(): Promise<User> {


        if (!this.authenticated) {
            return this.login()
                .then(x => this._user);
        }
        else {
            return new Promise((resolve) => {
                resolve(this._user);
            });

        }
    }

    public get authenticated() {
        return (this._user !== undefined && this._user != null);
    }

    //#endregion

    //#region ctor

    constructor(private router: Router, private http: Http) {

    }

    //#endregion

    //#region public methods

    public isAuthorized = (roles: string[]) => {

        if (!this.authenticated) return false;
        if (roles == null) return false;


        for (let role of roles.map(x => x.toLowerCase())) {
            if (this._user.claims.some(x => x.key == "authorization" && x.value.toLowerCase() == role))
                return true;
        }

        return false;
    }

    //#endregion

    //#region private methods


    private getUserFromSession(): User {
        let user = sessionStorage.getItem(USER_SESSION);
        if (user)
            return JSON.parse(user);

        return null;
    }

    private setUSerToSession(user: User) {
        if (user)
            sessionStorage.setItem(USER_SESSION, JSON.stringify(user));
    }

    private login() {

        //only request user info once
        if (!this.authenticationInProgress) {

            this.authenticationInProgress = true;
            this._loginPromise = this.http.get(config.apiUrl + "/security/user")
                .toPromise()
                .then(response => {
                    let user = response.json() as User;
                    this._user = user;
                    this.authenticationInProgress = false;
                })
                .catch(reason => {

                    console.log('Unable to authenticate user. reason: ' + reason);
                    //create a 'void' user in case of error
                    //that way the application will still continue to work
                    this._user = {
                        fullName: '',
                        firstName: '',
                        lastName: '',
                        login: '',
                        claims: [],
                        divisions: []
                    };
                    this.authenticationInProgress = false;
                });
        }

        //else return the resolved promise
        return this._loginPromise;

    }

    //#endregion



}